function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.344 7.531v.01c0 .501 0 1.222.317 2.115.319.896.94 1.922 2.116 3.098 1.816 1.816 3.804 3.268 4.557 3.796.401.281.932.281 1.333 0 .753-.529 2.74-1.98 4.556-3.796 1.177-1.176 1.797-2.202 2.116-3.098.317-.893.317-1.614.317-2.116v-.009c0-2.296-1.571-4.281-4-4.281-1.135 0-2.013.532-2.664 1.205A6.682 6.682 0 009 5.815a6.682 6.682 0 00-.992-1.36c-.651-.673-1.53-1.205-2.664-1.205-2.429 0-4 1.985-4 4.281z",
  strokeWidth: 1.25
});

var SvgThreadsLike = function SvgThreadsLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-label": "Like",
    viewBox: "0 0 18 18",
    stroke: "#424242",
    fill: "transparent"
  }, props), _ref);
};

export default SvgThreadsLike;